export default "__VITE_ASSET__Dw40yi4T__"